import { Controller } from '@hotwired/stimulus';

// Minimal cocoon-style nested form: "Add" clones a hidden <template> row
// (replacing the NEW_RECORD placeholder index with a unique one), "Remove"
// either drops a not-yet-persisted row from the DOM or flags a persisted row
// with its _destroy hidden field so the server deletes it on save.
export default class extends Controller {
  static targets = ['rows', 'template'];

  add(event) {
    event.preventDefault();
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString());
    this.rowsTarget.insertAdjacentHTML('beforeend', html);
  }

  remove(event) {
    event.preventDefault();
    const row = event.target.closest('[data-nested-form-row]');
    const destroyField = row.querySelector("input[name*='_destroy']");

    if (destroyField) {
      destroyField.value = '1';
      row.style.display = 'none';
    } else {
      row.remove();
    }
  }
}
